module.exports = __webpack_public_path__ + "static/media/Beneficios.f405d936.jpg";